import { z } from 'zod';

export function hasAtLeastTwoNameParts(value: string): boolean {
  return value.trim().split(/\s+/).filter(Boolean).length >= 2;
}

export const nomeCompletoSchema = z
  .string()
  .trim()
  .min(1, 'Nome completo é obrigatório')
  .refine(hasAtLeastTwoNameParts, {
    message: 'Informe nome e sobrenome',
  });
